module.exports = __webpack_public_path__ + "static/crossing-the-chasm-9dbcbfc54a2c853a2822a5f9d04b4cfa.jpg";